import { Component, HostBinding, Input } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { map } from 'rxjs/operators';
import { CustomOhgarTextAndFloatingBannerData } from './custom-ohgar-text-and-floating-banner.model';

@Component({
  selector: 'app-custom-ohgar-text-and-floating-banner',
  templateUrl: './custom-ohgar-text-and-floating-banner.component.html',
  styleUrls: ['./custom-ohgar-text-and-floating-banner.component.scss'],
  standalone: false
})
export class CustomOhgarTextAndFloatingBannerComponent {
  @Input() item: CustomOhgarTextAndFloatingBannerData;
  @HostBinding('class') styleClasses: string;

  constructor(public component: CmsComponentData<CustomOhgarTextAndFloatingBannerData>) { }

  data$ = this.component.data$.pipe(map(component => component));
}
